import Vue from "vue"
import VueRouter from "vue-router"
import store from "@store"

function load(name) {
  return () => import(`@/views/${name}.vue`)
}

Vue.use(VueRouter)
const routes = [
  {
    path: "/signup",
    name: "Register",
    props: true,
    component: load("Authentication/Login-2"),
  },
  {
    path: "/login",
    name: "Login",
    props: true,
    component: load("Authentication/Login-2"),
  },
  {
    path: "/otp",
    name: "OTP",
    component: load("Authentication/OTP"),
  },
  {
    path: "/change-phone",
    name: "ChangePhone",
    component: load("Authentication/ChangePhone"),
  },
  {
    path: "/change-phone-otp",
    name: "OTPChangePhone",
    component: load("Authentication/OTPChangePhone"),
  },
  {
    path: "/feedback/:uoc",
    name: "feedback",
    component: load("customerFeedback/feedback"),
    async beforeEnter(to, from, next) {
      if(from.name == null && to.name == 'feedback'){
        localStorage.setItem('stop-review', true)
        next({
          name: "Home",
          params: {
            restaurant_aliase: store.getters["restaurant/restaurantUUID"],
            branch_aliase: store.getters["branch/branchUUID"],
          },
        })
      }
      else{
        next()
      }
    }
  },
  {
    path: "/:restaurant_aliase/:branch_aliase",
    name: "Home",
    props: true,
    component: load("Home"),
  },
  {
    path: "/promotion-detail",
    name: "PromotionDetail",
    component: load("Promotion/PromotionDetail")
  },
  {
    path: "/coupon",
    name: "Coupon",
    component: load("Coupon/Coupon")
  },
  {
    path: "/coupon-redeem",
    name: "CouponCode",
    component: load("Coupon/CouponCode")
  },
  {
    path: "/card",
    name: "Card",
    component: load("MemberCard"),
  },
  {
    path: "/account",
    name: "Account",
    component: load("Account")
  },
  {
    path: "/history",
    name: "History",
    component: load("History")
  },
  {
    path: "/profile",
    name: "Profile",
    component: load("Profile")
  },
  {
    path: "/profile-setting",
    name: "ProfileSetting",
    component: load("ProfileSetting")
  },
  {
    path: "/tier-detail",
    name: "TierDetail",
    component: load("MembershipTier/TierDetail")
  },
  {
    path: "/thankyou-feedback",
    name: "thankUForfeedback",
    component: load("customerFeedback/thankyou")
  },
  {
    path: "/404",
    name: "NotFound",
    component: load("NotFound"),
  },
  {
    path: "/:restaurant_aliase",
    name: "HomeByRestaurant",
    props: true,
    component: load("Home"),
  },
  {
    path: "*",
    redirect: { name: "NotFound" },
  }
]

const pathAuth = ["Login", "Register", "OTP"]
const overrideAll = ["EnterpriseRegisterTana"];
const router = new VueRouter({ mode: "history", routes })
router.beforeEach(async (to, from, next) => {
  if (overrideAll.includes(to.name)) {
    next();
    return;
  }
  let auth = store.getters["auth/isLoggedIn"];
  let restaurantUUID = store.getters["restaurant/restaurantUUID"];
  let branchUUID = store.getters["branch/branchUUID"];
  let restaurantInfo = store.getters["restaurant/restaurantInfo"];
  let branchInfo = store.getters["restaurant/branchInfo"];
  if(auth) {
    store.dispatch('user/setUserInactive', false)
    await store.dispatch('auth/checkLogin')
    // Check member inactive
    const payload = {
      restaurantAlias: restaurantInfo.restaurantUUID,
      PhoneNumberRef1: localStorage['user-info'] ? JSON.parse(localStorage['user-info']).phoneNumber : null
    };
    const isPhoneNumber = await store.dispatch('auth/checkPhoneNumber', payload)
        .then((response) => {
          return response;
        })
        .catch((error) => {
          if(error.response.status == 404 && (error.response.data.message.includes('Inactive Member'))) {
            store.dispatch('user/setUserInactive', true)
          } else {
            return false;
          }
        });
  }

  // Remark - Working when scan QR
  // Set uniqueOrderCode
  if (to.query.uoc && to.query.pi) {
    store.commit("bill/SET_UOC", {
      uoc: to.query.uoc,
      points: to.query.pi,
    });
    store.commit("feedback/SET_UOC",  to.query.uoc);
  }

  if( (to.name === "Register" || to.name === "Login") && !restaurantUUID){
    const restaurantParam = to.query.restaurant_aliase;
    const branchParam = to.query.branch_aliase;
    let data = {
      restaurant: restaurantParam,
    }
    if (branchParam) data.branch = branchParam
    
    let dataAliase = await store
        .dispatch(
          "convertAliase",
          data,
        );
    restaurantUUID = dataAliase.restaurant_uuid;
    branchUUID = dataAliase.branch_uuid;

    await store.dispatch("restaurant/setRestaurant", {
      restaurantUUID, 
      branchUUID: branchUUID? branchUUID: false 
    });
  }

  if (to.name === "Home") {
    const restaurantParam = to.params.restaurant_aliase;
    const branchParam = to.params.branch_aliase;

    if ((branchUUID != branchParam || restaurantUUID != restaurantParam ) && restaurantParam != 'feedback') {
      // Remark - Convert Restaurant and Branch UUID to Aliase | Aliase to UUID
      let dataAliase = await store
        .dispatch(
          "convertAliase",
          {
            restaurant: restaurantParam,
            branch: branchParam,
          },
        );
      restaurantUUID = dataAliase.restaurant_uuid;
      branchUUID = dataAliase.branch_uuid;

      await store.dispatch("restaurant/setRestaurant", {restaurantUUID, branchUUID: branchUUID });
    }
    await store.dispatch("branch/forceLogoutWhenExpiredAllCRMBranch");

  } else if( to.name === "HomeByRestaurant"){
    const restaurantParam = to.params.restaurant_aliase;

    if (restaurantUUID != restaurantParam) {
      let dataAliase = await store
        .dispatch(
          "convertAliase",
          {
            restaurant: restaurantParam
          },
        );
      restaurantUUID = dataAliase.restaurant_uuid;

      await store.dispatch("restaurant/setRestaurant", {restaurantUUID, branchUUID: false});
    }
    await store.dispatch("branch/forceLogoutWhenExpiredAllCRMBranch");

  } else if (to.name === "NotFound") {
    // When user have UUID but haven't Info
    if (
      (restaurantUUID && branchUUID) &&
      !(restaurantInfo && branchInfo)
    ) {
      await store.dispatch("restaurant/fetchRestaurantInfo", restaurantUUID);
      await store.dispatch("branch/fetchBranchInfo", branchUUID);
    } else {
      return next();
    }

    if (auth) {
      if (restaurantUUID && branchUUID) {
        return next({
          name: "Home",
          params: {
            restaurant_aliase: store.getters["restaurant/restaurantUUID"],
            branch_aliase: store.getters["branch/branchUUID"],
          },
        })
      }
    } else {
      if(store.getters["restaurant/restaurantUUID"]){
        return next({ 
          name: "Login",
          query: {
            restaurant_aliase: to.params.restaurant_aliase,
            branch_aliase: to.params.branch_aliase
          },
        });
      }
    }
  }

  if (pathAuth.includes(to.name)) {
    if (auth) {
      if (restaurantUUID && branchUUID) {
        return next({
          name: "Home",
          params: {
            restaurant_aliase: store.getters["restaurant/restaurantUUID"],
            branch_aliase: store.getters["branch/branchUUID"],
          },
        })
      }
    }
  } else {
    if (auth) {
      if (to.query.uoc) {
        return next({ params: to.query });
      } else {
        return next();
      }
    } else {
      let queryRedirect = {
        restaurant_aliase: to.params.restaurant_aliase,
        branch_aliase: to.params.branch_aliase,
      }
      if (to.query.uoc) {
        queryRedirect = { ...queryRedirect, ...to.query }
      }
      return next({
        name: "Login",
        query: queryRedirect
      })
    }
  }

  return next();
})
export default router
